(function(utils) {
	
	utils.zBrojniSPaste = function(sifarnik, zbrojni){
		KUtils.busy(true);
		konto.sf.api.ZbrojniSPaste(zbrojni)
			.done(function(rez){
				sifarnik.kontoGrid.refresh(true);			
				sifarnik.zBrojniS.refresh(true);
				KUtils.busy(false);
			});	
	};
	
	utils.zBrojniSCopy = function(sifarnik){	
		var data = sifarnik.zBrojniS.getSelectedData();	
   		var dataCB = sifarnik.zBrojniS.getCheckedData();
   		if (dataCB.length == 0){  			
   			dataCB.push(data.ZBROJNIS);   			
   		}else{
   			$.each(dataCB, function (key, value) {
				dataCB[key] = value.ZBROJNIS;
			});
   		}
   		
   		KUtils.busy(true);
		konto.sf.api.ZbrojniSCopy(dataCB)
			.done(function(rez){
				KUtils.busy(false);
			});			
	};
	
	utils.zBrojniValidacijaStatusa = function(sifarnik){	
		var istiStatus = true;
		
   		var dataCB = sifarnik.kontoGrid.getCheckedData();
   		if ((dataCB.length == 0) || (dataCB.length == 1)){  			
   			istiStatus = true;  			
   		}else{
   			var pocStatus = dataCB[0].STATUS;
   			$.each(dataCB, function (key, value) {
				istiStatus2 = (value.STATUS == pocStatus);
				if(istiStatus2 == false){
					istiStatus = false;
				}
			});
   		}
		return istiStatus;
	};	
	
	utils.zBrojniSBrisanjeClick = function(sifarnik){
		var objZbrojni = sifarnik.kontoGrid.getSelectedData();
        var data = sifarnik.zBrojniS.getSelectedData();
        konto.sf.api.GetZbrojniZakljucan(objZbrojni.ZBROJNI).then(function(rez){
           if (rez.FWarningMsg != ""){
                konto.dialogs.upozori({width:"35%", content: rez.FWarningMsg });  
           }else{
           		var dataCB = sifarnik.zBrojniS.getCheckedData();
           		var dataCBR = sifarnik.zBrojniS.getCheckedData();
           		if (dataCB.length == 0){
           			var data = sifarnik.zBrojniS.getSelectedData();
           			dataCB.push(data.ZBROJNIS);
           			dataCBR.push(data.REDNI);
           		}else{
           			$.each(dataCB, function (key, value) {
        				dataCB[key] = value.ZBROJNIS;
        				dataCBR[key] = value.REDNI;
        			});
           		}
           		poruka = 'Obrisati stavke: ' + dataCBR.join() + '?';
                konto.dialogs.modal({
                    title: "Upozorenje",
                    content: poruka,
                    width: '600px',
                    buttons: {
                        "Da": {
                            click: function () {
                                var that = this;
                                KUtils.busy(true);
                                konto.sf.api.ZbrojniSObrisiList(dataCB)
                                    .done(function(){
                                        sifarnik.zBrojniS.refreshAfterDelete(); 
                                		KUtils.busy(false);  
                                    });
                                that.close();
                            },
                            isPrimary: true
                        },
                        "Ne": {
                            click: function () { this.close(); },
                        }
                    }
                });
            
			}	    
        }); 
	};	
	
	utils.vrijednostUDomacojValutiPremaTecaju = function(vrijednostUValuti, tecaj, godina, brojDecimala){
		if (brojDecimala == undefined)
			brojDecimala = 8;
		if(utils.godinaJeNakonUvodjenjaEura(godina))
			if (tecaj == 0.0000000)
				return 0;
			else
				return  KUtils.formatFloat(vrijednostUValuti / tecaj, brojDecimala);
		else
			return  KUtils.formatFloat(vrijednostUValuti * tecaj, brojDecimala);	
	};
	
	utils.vrijednostUStranojValutiPremaTecaju = function(vrijednostUValuti, tecaj, godina, brojDecimala){
		if (brojDecimala == undefined)
			brojDecimala = 8;
		if(utils.godinaJeNakonUvodjenjaEura(godina))
			if (tecaj == 0.0000000)
				return 0;
			else
				return  KUtils.formatFloat(vrijednostUValuti * tecaj, brojDecimala);
		else
			return  KUtils.formatFloat(vrijednostUValuti / tecaj, brojDecimala);
	};		
		
	utils.vrijednostUDomacojValutiPremaTecajuNaDan = function(vrijednostUValuti, tecaj, datum,  brojDecimala){
		if (brojDecimala == undefined)
			brojDecimala = 8; 
		if(utils.datumJeNakonUvodjenjaEura(datum))
			if (tecaj == 0.0000000)
				return 0;
			else
				return  KUtils.formatFloat(vrijednostUValuti / tecaj, brojDecimala);
		else
			return  KUtils.formatFloat(vrijednostUValuti * tecaj, brojDecimala);	
	};
	
	utils.vrijednostUStranojValutiPremaTecajuNaDan = function(vrijednostUValuti, tecaj, datum, brojDecimala){
		if (brojDecimala == undefined)
			brojDecimala = 8;
		if(utils.datumJeNakonUvodjenjaEura(datum))
			if (tecaj == 0.0000000)
				return 0;
			else
				return  KUtils.formatFloat(vrijednostUValuti * tecaj, brojDecimala);
		else
			return  KUtils.formatFloat(vrijednostUValuti / tecaj, brojDecimala);	
	};
	
	utils.godinaJeNakonUvodjenjaEura = function(godina){
		return parseInt(godina) >= parseInt("2023");
	};
	
	utils.datumJeNakonUvodjenjaEura = function(datum){
		datum = KUtils.Date(datum); 
		godina = datum.getFullYear();		
		return(godina >= 2023);
	};
		
} (konto.sf.utils = {}));